import styled from 'styled-components';

export const FormDivider = styled.hr`
  border: none;
  border-bottom: 2px solid
    ${props =>
      props.theme.colors.core?.gray[200]?.hex ??
      props.theme.colors.primaryColor};
  margin: 2rem auto 1rem auto;

  @media (max-width: 1000px) {
    border-bottom-width: 1px;
    margin: 1rem auto 1rem auto;
  }
`;
